import React from "react";
import { Box, Paper, Typography, Chip } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import PersonOffIcon from "@mui/icons-material/PersonOff";

const badgeColors = { GREEN: "#22c55e", YELLOW: "#f59e0b", RED: "#ef4444" };

export default function BlockStatsWidget({ data }) {
  if (!data) return null;
  const { blockRate, blockCount, totalContacts, recentBlocks, blockedContacts, badge } = data;

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
        <Typography fontWeight={700} fontSize={15} color="#1e293b">Block Rate</Typography>
        <Chip label={badge} size="small" sx={{ color: "#fff", bgcolor: badgeColors[badge], fontWeight: 700 }} />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        <BlockIcon sx={{ fontSize: 32, color: blockRate > 1 ? "#ef4444" : "#22c55e" }} />
        <Box>
          <Typography fontWeight={800} fontSize={28} color="#1e293b">{blockRate}%</Typography>
          <Typography variant="caption" color="#64748b">{blockCount} blocked / {totalContacts} total</Typography>
        </Box>
      </Box>
      {recentBlocks > 0 && (
        <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: "rgba(239,68,68,0.08)", border: "1px solid #fecaca", mb: 1.5 }}>
          <Typography variant="body2" color="#991b1b" fontWeight={600}>{recentBlocks} blocks in last 7 days</Typography>
        </Box>
      )}
      {blockedContacts && blockedContacts.length > 0 && (
        <Box>
          <Typography variant="caption" color="#64748b" fontWeight={600} mb={0.5} display="block">Recent blocked contacts:</Typography>
          {blockedContacts.slice(0, 5).map((c, i) => (
            <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.3 }}>
              <PersonOffIcon sx={{ fontSize: 14, color: "#ef4444" }} />
              <Typography variant="body2" color="#475569" sx={{ flex: 1 }}>{c.userName || c.sessionId}</Typography>
              <Typography variant="caption" color="#94a3b8">{c.blockedAt ? new Date(c.blockedAt).toLocaleDateString() : "—"}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
}
